import React from 'react';
import Header from '../global/Header';
import Images from '../../assets/images/index';
import GlobalContext from '../../context/global-context';
import isAuth from '../../components/login/IsAuth';
import { Translation } from 'react-i18next';


class FavoritesScreen extends React.Component {

    static contextType = GlobalContext;

    constructor(props){
      super(props);

      this.state = {
        location: null,
        favorites: [],
      }
    }

    componentDidMount(){
    }

    favorites = () => {
      return this.context.getFavorites().map(favorite => (
        <a href="JavaScript:void(0);" style={styles.favorite} key={favorite.id} onClick={() => this.props.history.push('/Location/'+favorite.id )}>
          <div style={styles.icon}>
            <img src={Images.pins.open} style={{width: 34, height: 50}} alt="Favorite" />
          </div>
          <div style={styles.detail}>
              <span style={styles.title}>{favorite.name}</span>
              <span style={styles.address}>{this.context.getSiteAddress(favorite.id)}</span>
          </div>
          <div style={styles.arrow}>
            <img src={Images.navArrowGrey} style={{width: 18, height: 18}} alt="Go to favorite" />
          </div>
        </a>
      ));
    }

    render() {
        return (
        <Translation>{t => 
          <div style={styles.container}>
             <Header title={t('TITLE_FAVOURITES')} history={this.props.history} />
          
              <div style={styles.container}>

                {!this.context.account.favorites.length && <div style={styles.emptyContainer}><span>{t('FAVOURITES_NONE')}</span></div>}
              
                {this.context.account.favorites.length > 0 && <div style={{flex:1}}>
                  {this.favorites()}
                </div>}
              </div>
          </div> 
          }</Translation>
        );
    }
}

export default isAuth(FavoritesScreen);

const styles = {
  container: {
    backgroundColor: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  emptyContainer: {
    flex:1, 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    color: '#a2a2a2'
  },
  favorite: {
    width: '100%',
    height: 100,
    flex: 1,
    flexWrap:'wrap',
    display: 'flex', 
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: '#e8e8e8',
    cursor: 'pointer'
  },
  icon: {
      height: '100%',
      width: '20%',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
  },
  detail: {
      height: '100%',
      width: '70%',
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center'
  },
  arrow: {
      height: '100%',
      width: '10%',
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center'
  },
  title: {
      color: '#484848',
      fontSize: 20
  },
  address: {
      color: '#484848',
      fontSize: 14
  }
};
